import { Navigate, Route, Routes } from 'react-router-dom';

import MembershipsTable from 'src/features/membership/components/table/MembershipsTable';
import MembershipDashboard from 'src/features/membership/components/MembershipDashboard';
import { ALL_CATEGORIES } from 'src/features/membership/utils/constants';
import { PERMISSION } from 'src/features/auth';
import useHasPermissions from 'src/hooks/useHasPermissions';

const MembershipsRoutes = () => {
    const accessMemberships = useHasPermissions([PERMISSION.ACCESS_MEMBERSHIPS]);

    return (
        <Routes>
            <Route index element={<Navigate to={ALL_CATEGORIES} replace />} />
            <Route path=":category">
                {accessMemberships && <Route path="" element={<MembershipsTable />} />}
                {accessMemberships && (
                    <Route path=":membershipId/:membershipTypeId" element={<MembershipDashboard />} />
                )}
            </Route>
            {accessMemberships && <Route path=":category/:membershipId" element={<MembershipDashboard />} />}
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default MembershipsRoutes;
